import AxiosInstance from "@/config/AxiosInstance";
import { API_BASE_URL, API_BASE_URL_OPEN } from "@/config/appConfig";

type GetTeamMembersParams = {
  participantId: unknown;
  page?: number;
  row?: number;
  searchKey?: string;
};

type ServicePayload = Record<string, unknown>;

export const userManagementService = {
  getTeamMembers({
    participantId,
    page = 1,
    row = 25,
    searchKey = "",
  }: GetTeamMembersParams) {
    return AxiosInstance.get(`${API_BASE_URL}/participant/team-members`, {
      params: {
        participant_id: participantId,
        page,
        row,
        searchKey,
      },
    });
  },

  inviteTeamMember(payload: ServicePayload) {
    return AxiosInstance.post(
      `${API_BASE_URL}/participant/team-members`,
      payload
    );
  },

  updateTeamMember(participantSubUserId: unknown, payload: ServicePayload) {
    return AxiosInstance.put(
      `${API_BASE_URL}/participant/team-members/${participantSubUserId}`,
      payload
    );
  },

  resendInvite(participantSubUserId: unknown, payload: ServicePayload) {
    return AxiosInstance.post(
      `${API_BASE_URL}/participant/team-members/${participantSubUserId}/resend-invite`,
      payload
    );
  },

  cancelInvite(participantSubUserId: unknown, payload: ServicePayload) {
    return AxiosInstance.post(
      `${API_BASE_URL}/participant/team-members/${participantSubUserId}/cancel-invite`,
      payload
    );
  },

  updateStatus(participantSubUserId: unknown, payload: ServicePayload) {
    return AxiosInstance.patch(
      `${API_BASE_URL}/participant/team-members/${participantSubUserId}/status`,
      payload
    );
  },

  resetPassword(participantSubUserId: unknown, payload: ServicePayload) {
    return AxiosInstance.post(
      `${API_BASE_URL}/participant/team-members/${participantSubUserId}/reset-password`,
      payload
    );
  },

  acceptTerms() {
    return AxiosInstance.post(`${API_BASE_URL_OPEN}/terms/accept`);
  },
};
